import React from 'react';

type IframeProps = {
    title: string;
    src: string;
    width: string;
    height: string;
};

export const Iframe: React.FC<IframeProps> = ({ title, src, width, height }) => {
    return <iframe title={title} src={src} width={width} height={height} frameBorder="0" />;
};
